import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'

class ButtonCallToAction extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    if (this.shadowRoot) {
      tryLoadDependencies(document, [
        WebAwesomeComponent.Icon,
        WebAwesomeComponent.Spinner,
        WebAwesomeComponent.Button,
      ])

      this.shadowRoot.innerHTML = `<div id="result" style="display: none;">Loading...</div>
    <wa-spinner id="loading"></wa-spinner>
    <wa-icon id="loaded" name="check" style="display:none;"></wa-icon>
    <wa-button id="btnCallToAction" size="small" class="primary-button" @click="onClick">
    <wa-icon slot="prefix" name="gear" variant="solid"></wa-icon>
    <slot></slot>
  </wa-button>`
    }
  }

  connectedCallback() {
    const btn = this.shadowRoot?.getElementById('btnCallToAction')
    if (btn) {
      this.listen(btn, this.formatDate)
    }

    const style = document.createElement('style')
    style.textContent = `
wa-button.primary-button::part(base) {
  border-radius: 6px;
  border: solid 2px;
  background: var(--wa-color-trustage-yellow-90);
  border-top-color: var(--wa-color-trustage-yellow-95);
  border-left-color: var(--wa-color-trustage-yellow-95);
  border-bottom-color: var(--wa-color-trustage-yellow-80);
  border-right-color: var(--wa-color-trustage-yellow-80);
  color: var(--wa-color-digital-blue-05);
  font-size: 1.125rem;
  box-shadow: 0 2px 10px #0002;
  transition: all var(--wa-transition-slow) var(--wa-transition-easing);
}

wa-button.primary-button::part(base):hover {
  transform: scale(1.05);
}

wa-button.primary-button::part(base):active {
  border-top-color: var(--wa-color-trustage-yellow-80);
  border-right-color: var(--wa-color-trustage-yellow-95);
  border-bottom-color: var(--wa-color-trustage-yellow-95);
  border-left-color: var(--wa-color-trustage-yellow-80);
  transform: translateY(1px);
}

wa-button.primary-button::part(base):focus-visible {
  outline: dashed 2px deeppink;
  outline-offset: 4px;
}
    `
    this.shadowRoot?.appendChild(style)

    setTimeout(() => {
      // Optionally, dispatch a custom event with the data
      const message =
        'WebComponent: Button Loaded. Log analytics at: ' + this.formatDate(new Date())
      console.log(message)
      const data = {
        message: message,
      }

      const resultElement = this.shadowRoot?.getElementById('result')
      if (resultElement) {
        resultElement.textContent = JSON.stringify(data, null, 2)
        this.dispatchEvent(new CustomEvent('button-call-toaction', { detail: message }))
        resultElement.style.display = 'none'
        resultElement.style.display = 'inline-block'
      }
    }, 2000)
  }

  listen(el: any, formatDate: (date: Date) => string) {
    //console.log('Listening for click events on:', el)
    el.addEventListener('click', function () {
      console.log('WebComponent: Button Clicked. Log analytics at: ' + formatDate(new Date()))
    })
  }

  private formatDate(date: Date): string {
    const d = new Date(date)
    const hour = d.getHours()
    const minute = d.getMinutes()
    const second = d.getSeconds()
    return `${hour}:${minute}:${second}`
  }
}

if (!customElements.get('ts-button-calltoaction')) {
  customElements.define('ts-button-calltoaction', ButtonCallToAction)
}
export { ButtonCallToAction }